var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-user-info" }, [
    _c("div", { staticClass: "boss-user-info-left" }, [
      _c(
        "div",
        {
          staticClass: "boss-send-target",
          attrs: { "data-test": "target-count" },
        },
        [
          _vm._v(
            "\n      送信対象（" + _vm._s(_vm.checkedMemberCount) + "名）\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "vertical boss-send-target-info" },
        [
          _vm._l(_vm.renderingMembers, function (member, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "boss-send-target-item",
                class: { "is-active": _vm.currentUserIndex == index },
              },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.canShowUser(member.checked),
                        expression: "canShowUser(member.checked)",
                      },
                    ],
                    staticClass: "boss-user-data",
                    attrs: { "data-test": "user-info-" + index },
                    on: {
                      click: function ($event) {
                        return _vm.selectUser(index)
                      },
                    },
                  },
                  [
                    _vm.isEdit
                      ? _c("input", {
                          staticClass: "boss-input-checkbox margin-auto",
                          attrs: {
                            type: "checkbox",
                            "data-test": "user-check-" + index,
                          },
                          domProps: {
                            checked: member.checked,
                            value: member.id,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onUserChecked(!member.checked, index)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "boss-user-data-left" }, [
                      _c(
                        "span",
                        {
                          attrs: { "data-test": "img-click" },
                          on: {
                            click: function ($event) {
                              _vm.isEdit
                                ? _vm.onUserChecked(!member.checked, index)
                                : ""
                            },
                          },
                        },
                        [
                          _vm.isNew(member)
                            ? _c("img", {
                                staticClass:
                                  "boss-user-data-image pega-margin-x-3",
                                attrs: {
                                  alt: "ID:" + member.id,
                                  "data-test": "boss-avatar-new",
                                  src: require("@/assets/images/boss-avatar-new.svg"),
                                },
                              })
                            : _c("img", {
                                staticClass:
                                  "boss-user-data-image pega-margin-x-3",
                                attrs: {
                                  alt: "ID:" + member.id,
                                  "data-test": "boss-avatar",
                                  src: require("@/assets/images/boss-avatar.svg"),
                                },
                              }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "boss-user-data-id" }, [
                        _c("span", [_vm._v("ID:" + _vm._s(member.id))]),
                        _vm._v(" "),
                        !member.checked
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "boss-annotation-text font-size-1-3em",
                              },
                              [
                                _vm._v(
                                  "\n                送信対象外\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("scout-resume-member-summary", {
                      staticClass:
                        "boss-user-data-right display-block margin-auto width-100",
                      attrs: { member: member },
                    }),
                  ],
                  1
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c("infinity-scroll", {
            attrs: {
              objects: _vm.members,
              "infinity-objects": _vm.renderingMembers,
              number: _vm.infinityScrollNumber,
            },
            on: {
              "update:infinityObjects": function ($event) {
                _vm.renderingMembers = $event
              },
              "update:infinity-objects": function ($event) {
                _vm.renderingMembers = $event
              },
            },
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "boss-user-info-right" }, [
      _c("div", { staticClass: "boss-user-resume" }, [
        _vm._v("\n      会員レジュメ\n    "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "boss-tabs-content-resume" },
        _vm._l(_vm.renderingMembers, function (member, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "boss-tabs-content-wrap",
              class: { "is-active": _vm.currentUserIndex == index },
            },
            [_c("scout-member-career-resume", { attrs: { member: member } })],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }